require("./SummaryComment.less");

const React = require("react");

const SummaryComment = React.createClass({
    propTypes: {
        Comment: React.PropTypes.string.isRequired
    },
    render() {
        return (
            <footer className="cs-SummaryComment">                    
                <div className="cs-SummaryComment__Text">Comment: {this.props.Comment}</div>
            </footer>);
    }
});

module.exports = SummaryComment;


// WEBPACK FOOTER //
// ./src/components/SurveySummary/SummaryComment/SummaryComment.jsx